import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';

interface JobOpening {
  id: string;
  title: string;
  department: string;
  location: string;
  type: string;
  description: string;
  requirements: string[];
  responsibilities: string[];
}

@Component({
  selector: 'app-careers',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent],
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.css'],
})
export class CareersComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('pageContent') pageContent!: ElementRef;

  activeSection: string = '';
  private observer!: IntersectionObserver;
  private isScrolling = false;

  sections = [
    {
      id: 'our-story',
      title: 'Our Story',
      content: `
      <p>Markado was built by two university students from Tetovo who wanted to make buying and selling easier for everyone in North Macedonia.</p>
      <p>We’re passionate about connecting people and simplifying local commerce.</p>
    `,
    },
    {
      id: 'future',
      title: 'Our Future',
      content: `
      <p>Right now we’re growing the platform and focusing on user feedback.
      We’ll start hiring once we’re ready to scale - and we’ll post it here first!</p>
    `,
    },
  ];

  constructor() {}

  ngOnInit(): void {
    this.activeSection = this.sections[0]?.id || '';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.pageContent && this.pageContent.nativeElement) {
        this.pageContent.nativeElement.classList.add('loaded');
      }
      this.setupIntersectionObserver();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {}

  private setupIntersectionObserver(): void {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3,
    };

    this.observer = new IntersectionObserver((entries) => {
      if (this.isScrolling) return;

      const visibleEntries = entries.filter((entry) => entry.isIntersecting);

      if (visibleEntries.length > 0) {
        const firstVisible = visibleEntries[0];
        const sectionId = firstVisible.target.id;

        if (sectionId && this.activeSection !== sectionId) {
          this.activeSection = sectionId;
        }
      }
    }, options);

    this.sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        this.observer.observe(element);
      }
    });
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      this.isScrolling = true;
      this.activeSection = sectionId;

      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 80;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });

      setTimeout(() => {
        this.isScrolling = false;
      }, 1000);
    }
  }

  isActive(sectionId: string): boolean {
    return this.activeSection === sectionId;
  }

  trackBySection(index: number, section: any): string {
    return section.id;
  }
}
